import React from "react";
import "./RentBike.css";
import bicycle from "../../assets/bicycle.png";
import motorcycle from "../../assets/motorcycle.png";
import electric from "../../assets/electric.png";
import { Link } from "react-router-dom";
const RentBike = () => {
  return (
    <div className="rent-container">
      {/* Header */}
      <div className="rent-header">
        <h2>
          Rent. <span>Ride.</span> Repeat.
        </h2>
      </div>

      {/* Cards */}
      <div className="rent-cards">
        {/* Card 1 */}
        <Link to="/scooter-ride" className="rent-card-link">
          {" "}
          <div className="rent-card">
            <div className="price-badge">Rs--/hr</div>
            <img src={electric} alt="Electric Scooter" />
            <h3>Scooter</h3>
            <p>Eco-friendly rides</p>
          </div>
        </Link>

        {/* Card 2 */}
        <Link to="/motor-cycle" className="rent-card-link">
          {" "}
          <div className="rent-card">
            <div className="price-badge">Rs--/Day</div>
            <img src={motorcycle} alt="Motorcycle" />
            <h3>Motorcycle</h3>
            <p>Quick city travel</p>
          </div>
        </Link>
        {/* Card 3 */}
        <Link to="/bicycle" className="rent-card-link">
          {" "}
          <div className="rent-card">
            <div className="price-badge">$6/hr</div>
            <img src={bicycle} alt="Bicycle" />
            <h3>Bicycle</h3>
            <p>Healthy & green</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default RentBike;
